import apiService from 'frontcore/data/api-service/api-service'
import HttpStatusCode from 'frontcore/data/api-service/http-status-code'
import { IStandardAPIService, StandardMin } from 'frontcore/domain/standards/types'
import { StandardAPIServiceError } from 'frontcore/data/standards/types'


type StandardAPIResponse = {
  id: number
  created: string
  updated: string
  approved_date: string
  ascendants: number[]
  first_version_created: string
  is_active: boolean
  is_auditable: boolean
  is_beginner_friendly: boolean
  is_bottleneck: boolean
  is_in_paper: boolean
  is_minor_version: boolean
  name: string
  perimeters: number[]
  version_number: number
}

const parseStandardAPIResponse = (standardAPIResponse: StandardAPIResponse[]): StandardMin[] => {
  return standardAPIResponse.map(standard => {
    return {
      id: standard.id,
      created: standard.created,
      updated: standard.updated,
      approvedDate: standard.approved_date,
      ascendants: standard.ascendants,
      firstVersionCreated: standard.first_version_created,
      isActive: standard.is_active,
      isAuditable: standard.is_auditable,
      isBeginnerFriendly: standard.is_beginner_friendly,
      isBottleneck: standard.is_bottleneck,
      isInPaper: standard.is_in_paper,
      isMinorVersion: standard.is_minor_version,
      name: standard.name,
      perimeters: standard.perimeters,
      versionNumber: standard.version_number,
    }
  })
}

export default class StandardAPIService implements IStandardAPIService {
  async fetch (payload?: Record<string, unknown>): Promise<StandardMin[]>{
    const APIPayload = payload ?? {}
    try {
      const url = `standards/`
      const response = await apiService
        .buildRequest()
        .withSessionToken()
        .withQueryParameters({
          ...APIPayload,
          format: 'min',
        })
        .get<StandardAPIResponse[]>(url)

      if (response.status !== HttpStatusCode.OK) {
        throw new StandardAPIServiceError()
      }

      return parseStandardAPIResponse(response.data)

    } catch(e) {
      if (e instanceof StandardAPIServiceError) { throw e }

      throw new StandardAPIServiceError((e as Error).message)
    }
  }
}
